import { render, staticRenderFns } from "./SkimovieProblemsIssueSpots.vue?vue&type=template&id=81704c88&scoped=true&"
import script from "./SkimovieProblemsIssueSpots.vue?vue&type=script&lang=js&"
export * from "./SkimovieProblemsIssueSpots.vue?vue&type=script&lang=js&"
import style0 from "./SkimovieProblemsIssueSpots.vue?vue&type=style&index=0&id=81704c88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81704c88",
  null
  
)

export default component.exports